"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLevelPrizes = void 0;
var swr_hooks_1 = require("@l2p/swr-hooks");
var react_1 = require("react");
var next_intl_1 = require("next-intl");
var useLevelPrizes = function (level) {
    var currentCurrency = (0, swr_hooks_1.useCurrentCurrency)();
    var t = (0, next_intl_1.useTranslations)('translation');
    return (0, react_1.useMemo)(function () {
        var _a, _b, _c, _d, _e;
        var result = [];
        var cash = Number(((_b = (_a = level === null || level === void 0 ? void 0 : level.bonusMoney) === null || _a === void 0 ? void 0 : _a.amount) === null || _b === void 0 ? void 0 : _b[currentCurrency]) || 0);
        if (cash && cash > 0)
            result.push("".concat(cash, " ").concat(currentCurrency));
        if (((_c = level === null || level === void 0 ? void 0 : level.bonusFreeSpins) === null || _c === void 0 ? void 0 : _c.number) && ((_d = level === null || level === void 0 ? void 0 : level.bonusFreeSpins) === null || _d === void 0 ? void 0 : _d.number) > 0) {
            result.push("".concat((_e = level === null || level === void 0 ? void 0 : level.bonusFreeSpins) === null || _e === void 0 ? void 0 : _e.number, " ").concat(t('fs')));
        }
        return result;
    }, [currentCurrency, level, t]);
};
exports.useLevelPrizes = useLevelPrizes;
